import { HttpConfiguration } from '../configs/app.http.config';
import { RequestTypes } from '../models/request-types.enum';
import { Injectable } from '@angular/core';
import DictionaryStr from '../models/dictionary';

import { HttpClient, HttpParams, HttpHeaders  } from '@angular/common/http';

import { Observable } from 'rxjs';

@Injectable()
export class HttpService {
    protected server = '';
    protected actionUrl = '';
    protected headers: HttpHeaders;
    // protected options: RequestOptions;

    constructor(apiUrl: string, requestType: RequestTypes, private httpConfig: HttpConfiguration, private http: HttpClient/*, private jsonp: Jsonp*/) {

        // Http config
        this.server = httpConfig.Servers[requestType];

        // Action
        this.actionUrl += apiUrl;
        if (this.actionUrl.length > 0 && this.actionUrl[this.actionUrl.length - 1] !== '/') {
            this.actionUrl += '/';
        }

        // Headers
        const headersObject = {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        };
        this.headers = new HttpHeaders(headersObject);
    }

    protected get(methodName: string, queryParams: DictionaryStr<string>): Observable<any> {
        const options = {
            headers: this.headers,
            params: queryParams,
            withCredentials: false
        };

        return this.http.get(this.server + this.actionUrl + methodName, options);
    }

    protected post(methodName: string, object: any): Observable<any> {
        const options = {
            headers: this.headers
        };

        return this.http.post(this.server + this.actionUrl + methodName, object, options);
    }

    protected getUrl(url: string): Observable<any> {
        return this.http.get(url, (this.headers) as any);
    }

    //
    // ASYNC PROMISES
    //
    protected async postAsync<T>(methodName: string, object: any): Promise<any> {
        const options = {
            headers: this.headers,
            withCredentials: true
        };

        return await this.http.post(this.server + this.actionUrl + methodName, object, options)
            .pipe()
            .toPromise();
    }

    protected async getAsync<T>(methodName: string, queryParams: DictionaryStr<string>): Promise<any> {
        const params = new HttpParams();
        if (!!queryParams) {
            for (let pKey in queryParams) {
                const pValue = queryParams[pKey];
                if (!params.has(pKey)) {
                    params.set(pKey, pValue);
                }
            }
        }

        const options = {
            params: params,
        };

        return await this.http.get(this.server + this.actionUrl + methodName, options)
            .pipe()
            .toPromise();
    }

    protected async getJsonpAsync<T>(methodName: string, queryParams: DictionaryStr<string>): Promise<any> {
        const params = new HttpParams();
        if (!!queryParams) {
            for (let pKey in queryParams) {
                const pValue = queryParams[pKey];
                if (!params.has(pKey)) {
                    params.set(pKey, pValue);
                }
            }
            params.set('callback', 'JSONP_CALLBACK');
        }

        const options = {
            params: params,
        };

        return await this.http.get(this.server + this.actionUrl + methodName, options)
            .pipe()
            .toPromise();
    }
}


// WEBPACK FOOTER //
// ./src/custom_modules/autocomplete/services/http.service.ts